export var VERSION = '1.6.6';
//# sourceMappingURL=version.js.map